import MySlider from "components/MySlider";

const SectionSliderBandwidth = ({
  width,
  className = "",
  posts,
}) => {
  return (
    <div style={{backgroundColor:'red', paddingBottom:'10px', padding:'0px 10px 0px'}} className={`nc-SectionSliderPosts red-bandwidth ${className}`}>
      <MySlider
        width={width}
        data={posts}
      />
    </div>
  );
};

export default SectionSliderBandwidth;
